// Which Client Helper client a SharePoint client folder belongs to, for the
// upload page. A folder remembers the client someone picked for it (upload,
// push or approve; kept on the client's profile), and that wins over guessing
// from the folder name. The eMoney data is keyed by the client's id.

// Folder names as the server keys the mapping (whitespace collapsed).
export const normalizeFolder = (name) => String(name || '').split(/\s+/).filter(Boolean).join(' ');

/**
 * folder: the SharePoint folder chosen; folderClients: { [folder]: clientId };
 * knowledgebaseClients: [{ client_id, ... }]; match(folder): the name matcher,
 * { client, score } or null.
 * -> { clientId, source }: source is 'mapped' (the folder's own client),
 *    'match' (a strong name match), 'weak' (a weak one; client included for
 *    the warning), 'none' (no client: offer to create one) or 'cleared'.
 */
export const chooseFolderClient = (folder, folderClients, knowledgebaseClients, match) => {
  if (!folder) return { clientId: '', source: 'cleared' };
  const mapped = (folderClients || {})[normalizeFolder(folder)];
  if (mapped && (knowledgebaseClients || []).some((c) => c.client_id === mapped)) {
    return { clientId: mapped, source: 'mapped' };
  }
  const result = match(folder);
  if (result && result.score >= 2) return { clientId: result.client.client_id, source: 'match' };
  if (result && result.score === 1) return { clientId: result.client.client_id, source: 'weak', client: result.client };
  return { clientId: '', source: 'none' };
};
